import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MasterService } from 'src/app/base-classes/master-service';
import { AuthProfile } from 'src/app/shared/models/auth-profile.interface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthProfileService extends MasterService<AuthProfile> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}/auth-profiles`);
  }

  public createAuthProfile(item: Partial<AuthProfile>): Observable<AuthProfile> {
    return this.http.post<AuthProfile>(`${environment.apiUrl}/auth-profiles`, item);
  }

   override save(item: AuthProfile): Observable<AuthProfile> {
          if (item.id) {
              return this.updateAuthProfile(item);
          } else {
              return this.createAuthProfile(item);
          }
      }

  public updateAuthProfile(item: Partial<AuthProfile>): Observable<AuthProfile> {
    return this.http.post<AuthProfile>(`${environment.apiUrl}/auth-profiles`, item);
  }

  public getAllAuthProfiles() {
    return this.http.get<any[]>(`${environment.apiUrl}/auth-profiles/user-clients`);
  }

  public removeAuthProfile(id: string) {
    return this.http.delete(`${environment.apiUrl}/auth-profiles/${id}`);
  }


  // Get clients accessible by current user (based on token)
  public getMyClients() {
    return this.http.get<any[]>(`${environment.apiUrl}/clients/user-clients`);
  }

  // Get all Tenants
  public getTenantsAll() {
    return this.http.get<any[]>(`${environment.apiUrl}/tenants`);
  }

  // Get auth profiles by functional area (grouped by profileGroup)
  public getAuthProfilesByFunctionalArea(functionalAreaId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/auth-profiles/by-functional-area/${functionalAreaId}`);
  }
}